import { http } from 'services';

export function getInvitations(query, cbSuccess, cbError) {
  http.get(
    'invitations',
    query,
    (invitations) => {
      cbSuccess(invitations.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getInvitationDetails(id, cbSuccess, cbError) {
  http.get(
    `invitations/${id}`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function sendInvitation(payload, cbSuccess, cbError) {
  http.post(
    'invitations',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function resendInvitation(id, cbSuccess, cbError) {
  http.post(
    `invitations/${id}/resend`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function cancelInvitation(id, cbSuccess, cbError) {
  http.post(
    `invitations/${id}/cancel`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function deleteInvitation(id, cbSuccess, cbError) {
  http.delete(
    `invitations/${id}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-invitations/api-invitations-base.js